import * as React from 'react';
import {
  useQueryParam,
  StringParam,
  encodeQueryParams,
} from 'use-query-params';
import { stringify } from 'query-string';
import { useHistory } from 'react-router-dom';
import { SearchStyle } from '../../Config';
import { Actions as SearchActions } from '../../actions/search';
import { useSelector, useDispatch } from '../../actions/types';
import type { IUseSearch } from './index';
import { getOnChangeValue } from '../../utils';
import { getBaseUrl } from '../../utils/globals';

const logWarning = (name: string) => {
  const message = `${name}: should not call this function when using search results pages`;
  console.warn(message);
};

export default function useSearch(): IUseSearch {
  const dispatch = useDispatch();
  // Doing this so we preserve the version.
  const [version] = useQueryParam('version', StringParam);
  const baseUrl = getBaseUrl();
  const value = useSelector((state) => state.search.inputValue); // Search input
  const history = useHistory();

  const onChange = (
    eventOrValue: React.SyntheticEvent<HTMLInputElement> | string
  ) => {
    const val = getOnChangeValue(eventOrValue);
    dispatch(SearchActions.searchTermChanged(val, SearchStyle.resultsPage));
  };

  // Push a new search query
  const onSubmit = () => {
    if (value.length > 0) {
      const escQuery = encodeQueryParams(
        { query: StringParam, version: StringParam },
        { query: value, version }
      );
      history.push({
        pathname: `${baseUrl}/search`,
        search: stringify(escQuery),
      });
    }
  };

  // Submit the query on 'Enter'
  const onKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSubmit();
    }
  };
  return {
    value,
    onChange,
    onKeyUp,
    onSubmit,
    isOpen: false,
    onCloseDropdown: () => logWarning('onCloseDropdown'),
    onOpenDropdown: () => logWarning('onOpenDropdown'),
    onReset: () => logWarning('onReset'),
  };
}
